import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

const AddVocabArea = ({ methods, name, remove, index, placeholder }) => {
  const { control } = methods;
  return (
    <div className="flex gap-6 items-center">
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const { value, onChange, ...rest } = field;

          const handleChange = (event) => {
            const input = event.target.value;
            const lines = input.split("\n");
            // Only update if there are 10 or fewer lines
            if (lines.length <= 10) {
              onChange(input);
            }
          };

          return (
            <TextField
              {...rest}
              size="small"
              placeholder={placeholder}
              autoComplete="off"
              value={value || ""}
              onChange={handleChange}
              multiline
              rows={10}
              helperText={`${value ? value.split("\n").length : 0}`}
            />
          );
        }}
      />
    </div>
  );
};

export default AddVocabArea;
